exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clickable-card-icon[data-v-71c292df]{position:absolute;bottom:0;right:0;margin-right:.25rem;transform:rotate(45deg);font-size:18px}", ""]);

// exports
